import React from 'react';

// Styles & Assets
import styles from './OptionButtonSimple.module.css';

// Interfaces
interface Props {
    label: React.ReactNode
    selected?: boolean
}

const OptionButtonSimple: React.FC<(Props & React.HTMLAttributes<HTMLButtonElement>)> = ({ label, selected, ...props }) => {

    return (
        <button
            {...props}
            className={`${styles.buttonOption} ${selected ? styles.selected : ''}`}
        >
            {label}
        </button>
    );
};

export default OptionButtonSimple;